module.exports = __webpack_public_path__ + "img/desktop_summary_banner.25969a46.png";